/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface ServiceAccountBasicData
 *
 */
// create custom validators for the regexes
export interface ServiceAccountBasicData {
    /**
     *
     * #type string
     * #memberof ServiceAccountBasicData
        
        
         */
    id: string;
    /**
     *
     * #type string
     * #memberof ServiceAccountBasicData
        
        
         */
    name: string;
    /**
     * The user's token to be used for authentication via token querystring
     * #type string
     * #memberof ServiceAccountBasicData
        
        
    * @minLength 5
         */
    token: string;
    /**
     * unix timestamp in milliseconds
     * #type number
     * #memberof ServiceAccountBasicData
        
    * @minimum 0
            
         */
    createdAt: number;
}
/**
 * Check if a given object implements the ServiceAccountBasicData interface.
 */
export function instanceOfServiceAccountBasicData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "createdAt" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const ServiceAccountBasicDataTypiaAssertEquals = (input: any) => {
    return ((input: any): ServiceAccountBasicData => {
        const __is = (input: any, _exceptionable: boolean = true): input is ServiceAccountBasicData => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.id && "string" === typeof input.name && ("string" === typeof input.token && 5 <= input.token.length) && ("number" === typeof input.createdAt && 0 <= input.createdAt) && (4 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["id", "name", "token", "createdAt"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is ServiceAccountBasicData => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("string" === typeof input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && ("string" === typeof input.token && (5 <= input.token.length || $guard(_exceptionable, {
                    path: _path + ".token",
                    expected: "string (@minLength 5)",
                    value: input.token
                })) || $guard(_exceptionable, {
                    path: _path + ".token",
                    expected: "string",
                    value: input.token
                })) && ("number" === typeof input.createdAt && (0 <= input.createdAt || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number (@minimum 0)",
                    value: input.createdAt
                })) || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number",
                    value: input.createdAt
                })) && (4 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["id", "name", "token", "createdAt"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "ServiceAccountBasicData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "ServiceAccountBasicData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const ServiceAccountBasicDataTypiaAssertStringify = (input: ServiceAccountBasicData): string => {
    return ((input: any): string => { const assert = (input: any): ServiceAccountBasicData => {
        const __is = (input: any): input is ServiceAccountBasicData => {
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).id && "string" === typeof (input as any).name && ("string" === typeof (input as any).token && 5 <= (input as any).token.length) && ("number" === typeof (input as any).createdAt && !Number.isNaN((input as any).createdAt) && 0 <= (input as any).createdAt));
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is ServiceAccountBasicData => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("string" === typeof input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && ("string" === typeof input.token && (5 <= input.token.length || $guard(_exceptionable, {
                    path: _path + ".token",
                    expected: "string (@minLength 5)",
                    value: input.token
                })) || $guard(_exceptionable, {
                    path: _path + ".token",
                    expected: "string",
                    value: input.token
                })) && ("number" === typeof input.createdAt && !Number.isNaN(input.createdAt) && (0 <= input.createdAt || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number (@minimum 0)",
                    value: input.createdAt
                })) || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number",
                    value: input.createdAt
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "ServiceAccountBasicData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "ServiceAccountBasicData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: ServiceAccountBasicData): string => {
        const $string = (typia.createAssertStringify as any).string;
        return `{"id":${$string((input as any).id)},"name":${$string((input as any).name)},"token":${$string((input as any).token)},"createdAt":${(input as any).createdAt}}`;
    }; return stringify(assert(input)); })(input);
};
export const ServiceAccountBasicDataValidatorShape = {
    'id': yup.string().defined(),
    'name': yup.string().defined(),
    'token': yup.string().min(5).defined(),
    'createdAt': yup.number().min(0).defined(),
};
export const ServiceAccountBasicDataValidator = yup.object().shape(ServiceAccountBasicDataValidatorShape);
export const ServiceAccountBasicDataStringifyShapeProperties: ObjectSchema['properties'] = {
    'id': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'name': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'token': {
        'type': 'string',
        'minLength': 5,
    } as unknown as fastJSON.StringSchema,
    'createdAt': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
};
export const ServiceAccountBasicDataStringifyShape: ObjectSchema = {
    title: 'ServiceAccountBasicData Stringifier',
    type: 'object',
    properties: {
        ...ServiceAccountBasicDataStringifyShapeProperties
    },
    required: [
        'id',
        'name',
        'token',
        'createdAt',
    ],
};
export const ServiceAccountBasicDataStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(ServiceAccountBasicDataStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const ServiceAccountBasicDataStringify: (data: ServiceAccountBasicData) => string = ServiceAccountBasicDataStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function ServiceAccountBasicDataFromJSON(json: any): ServiceAccountBasicData {
    return ServiceAccountBasicDataFromJSONTyped(json, false);
}
export function ServiceAccountBasicDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAccountBasicData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'id': json['id'],
        'name': json['name'],
        'token': json['token'],
        'createdAt': json['createdAt'],
    };
}
export function ServiceAccountBasicDataToJSON(value?: ServiceAccountBasicData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'token': value.token,
        'createdAt': value.createdAt,
    };
}
